export default __webpack_public_path__ + "static/media/valentine_clivechristian-8.e195d6eb.jpg";